import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import { componentKey, setApiPortalLoginUrl, setDeveloperData, setIsActive, setIsMndaSigned, setIsRequestedProductionAppKey, setLoadingState, setProductionAppKey, setSandBoxAppKey, setSandBoxApplicationUrl, setShouldProductionKeyRequestManually, setShowInvitePopup, setShowProdAppKey, setTotalDeveloper, setUserType, } from './ApiSlice';
import ApiHubDataService from '../../../services/ApiHubDataService';
import { addNotifications } from '../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../components/toast/constants';
import { API_HUB_LOADING_STATES, COMMON_LOADING_STATES, PAGE_STATE } from '../constants/constants';

export const { getAPIDetails, enableApi, getDeveloperList, deleteDeveloper, inviteDeveloper, managerShowProdAppKey, disableApi, requestProductionKey } = {
	getAPIDetails: (payload) => {
		return {
			type: "APIHUB/GET_API_DETAILS",
			payload: payload
		}
	},
	enableApi: (payload) => {
		return {
			type: "APIHUB/ENABLE_API",
			payload: payload
		}
	},
	getDeveloperList: (payload) => {
		return {
			type: "APIHUB/GET_DEVELOP_LIST",
			payload: payload
		}
	},
	deleteDeveloper: (payload) => {
		return {
			type: "APIHUB/DELETE_DEVELOPER",
			payload: payload
		}
	},
	inviteDeveloper: (payload) => {
		return {
			type: "APIHUB/INVITE_DEVELOPER",
			payload: payload
		}
	},
	managerShowProdAppKey: (payload) => {
		return {
			type: "APIHUB/MANAGE_SHOW_PROD_APP_KEY_DEVELOP",
			payload: payload
		}
	},
	disableApi: (payload) => {
		return {
			type: "APIHUB/DISABLE_API",
			payload: payload
		}
	},
	requestProductionKey: (payload) => {
		return {
			type: "APIHUB/REQUEST_PRODUCTION_KEY",
			payload: payload
		}
	},
}

function* getAPIDetailsAsync() {
	try {
		yield put(setLoadingState({ state: API_HUB_LOADING_STATES.DETAIL_LOADING }));

		const response = yield ApiHubDataService.getApiDetails();
		if (response?.data?.Status && response.data.Status == 1) {
			yield put(setSandBoxAppKey(response?.data?.Data?.SandBoxAppKey))
			yield put(setProductionAppKey(response?.data?.Data?.ProductionAppKey))
			yield put(setIsMndaSigned(response.data?.Data?.IsMndaSigned))
			yield put(setIsActive(response.data?.Data?.IsActive ?? false))
			yield put(setShowProdAppKey(response?.data?.Data?.ShowProdAppKey))
			yield put(setUserType(response?.data?.Data?.UserType))
			yield put(setApiPortalLoginUrl(response?.data?.Data?.APIPortalLoginUrl))
			yield put(setSandBoxApplicationUrl(response?.data?.Data?.SandBoxApplicationUrl))
			yield put(setIsRequestedProductionAppKey(response?.data?.Data?.IsRequestedProductionAppKey))
			yield put(setShouldProductionKeyRequestManually(response?.data?.Data?.ShouldProductionKeyRequestManually))
		}
	}
	catch (error) {
		yield put(addNotifications({
			heading: "Error Getting API Details",
			message: error?.response?.data?.Message
		}));
	} finally {
		yield put(setLoadingState({ state: API_HUB_LOADING_STATES.DETAIL_READY }))
	}
}

function* enableApiAsync() {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
		const response = yield ApiHubDataService.enableApi();

		if (response?.data?.Status && response.data.Status == 1) {
			yield call(getAPIDetailsAsync)
		}
	}
	catch (error) {

		yield put(addNotifications({
			heading: "Error Enabling API",
			message: error?.response?.data?.Message
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* getDeveloperListAsync(action) {
	try {
		yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING}));
		const response = yield ApiHubDataService.getDeveloperList(action.payload);

		if (response?.data?.Status && response.data.Status == 1) {
			yield put(setDeveloperData(response.data.Data.Data))
			yield put(setTotalDeveloper(response.data.Data.Total))
		}
	}
	catch (error) {

		yield put(addNotifications({
			heading: "Error Fetching Developers",
			message: error?.response?.data?.Message
		}));
	} finally {
		yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
	}
}

function* deleteDeveloperAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
		const response = yield ApiHubDataService.deleteDeveloper(action.payload);

		if (response?.data?.Status && response.data.Status == 1) {
			yield call(getDeveloperListAsync, { payload: { memberName: '' }})
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS

			}));
		} else {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER

			}));
		}
	}
	catch (error) {

		yield put(addNotifications({
			heading: "Error Deleting Developer",
			message: error?.response?.data?.Message
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}

}

function* inviteDeveloperAsync(action) {
	try {
		yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_LOADING }));
		const response = yield ApiHubDataService.inviteDevelopers(action.payload);

		if (response?.data?.Status && response.data.Status == 1) {
			yield put(setShowInvitePopup(false));
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS

			}));
		} else {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER

			}));
		}
	}
	catch (error) {

		yield put(addNotifications({
			heading: "Error Deleting Developer",
			message: error?.response?.data?.Message
		}));
	} finally {
		yield put(setLoadingState({ state: COMMON_LOADING_STATES.GENERAL_READY }))
	}

}

function* managerShowProdAppKeyAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
		const response = yield ApiHubDataService.managerShowProdAppKey(action.payload);

		if (response?.data?.Status && response.data.Status == 1) {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS

			}));
			yield call(getDeveloperListAsync, { payload: { memberName: '' }})
		} else {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER

			}));
		}
	}
	catch (error) {

		yield put(addNotifications({
			heading: "Error Deleting Developer",
			message: error?.response?.data?.Message
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}

}

function* disableApiAsync() {
	try {
		yield put(setLoadingState({ state: API_HUB_LOADING_STATES.DISABLE_API_LOADING }));
		const response = yield ApiHubDataService.disableApi();

		if (response?.data?.Status && response.data.Status == 1) {
			yield put(addNotifications({
				heading: "Success",
				message: response?.data?.Message,
				variant: TOASTER_VARIANT.SUCCESS,
			}));
			yield call(getAPIDetailsAsync)
		}else{
			yield put(addNotifications({
				heading: "Error",
				message: response?.data?.Message,
			}));
		}
	}
	catch (error) {

		yield put(addNotifications({
			heading: "Error disabling API",
			message: error?.response?.data?.Message
		}));
	} finally {
		yield put(setLoadingState({ state: API_HUB_LOADING_STATES.DISABLE_API_READY }))
	}
}

function* requestProductionKeyAsync() {
	try {
		yield put(setLoadingState({ state: API_HUB_LOADING_STATES.REQUEST_PROD_KEY_LOADING }));
		const response = yield ApiHubDataService.requestProdAppKey();

		if (response?.data?.Status && response.data.Status == 1) {
			yield put(addNotifications({
				heading: "Success",
				message: response?.data?.Message,
				variant: TOASTER_VARIANT.SUCCESS,
			}));
			yield call(getAPIDetailsAsync)
		}else{
			yield put(addNotifications({
				heading: "Error",
				message: response?.data?.Message,
			}));
		}
	}
	catch (error) {
		console.log("error", error)
		yield put(addNotifications({
			heading: "Ran into error. Please try again later",
			message: error
		}));
	} finally {
		yield put(setLoadingState({ state: API_HUB_LOADING_STATES.REQUEST_PROD_KEY_READY }))
	}
}

function* rootSaga() {
	yield all([
		takeLatest(getAPIDetails().type, getAPIDetailsAsync),
		takeLatest(enableApi().type, enableApiAsync),
		takeLatest(getDeveloperList().type, getDeveloperListAsync),
		takeLatest(deleteDeveloper().type, deleteDeveloperAsync),
		takeLatest(inviteDeveloper().type, inviteDeveloperAsync),
		takeLatest(managerShowProdAppKey().type, managerShowProdAppKeyAsync),
		takeLatest(disableApi().type, disableApiAsync),
		takeLatest(requestProductionKey().type, requestProductionKeyAsync),
	]);
}

store.sagaManager.addSaga(componentKey, rootSaga);